export const CLOUDINARY_BASE = 'https://res.cloudinary.com/dtpseup2f/image/upload';

export const LOGO_PATH = `${CLOUDINARY_BASE}/v1589853868/letsbuildui/logo_g7p0cq.png`;
export const OG_LOGO_PATH = `${CLOUDINARY_BASE}/v1590877597/letsbuildui/og-default.png`;

export const MATCHMEDIA = {
  XSMALL: '(min-width: 320px)',
  SMALL: '(min-width: 540px)',
  MEDIUM: '(min-width: 768px)',
  MEDIUM_MID: '(min-width: 840px)',
  LARGE: '(min-width: 1080px)',
  XLARGE: '(min-width: 1200px)',
};

export const IMAGE_URLS = {
  MOBILE: `${CLOUDINARY_BASE}/f_auto,q_auto,w_768`,
  MOBILE_ASPECT_RATIO: `${CLOUDINARY_BASE}/f_auto,q_auto,w_768,ar_1.6`,
  DESKTOP: `${CLOUDINARY_BASE}/f_auto,q_auto`,
};
